import NoteBookComponent from "./components/NoteBookComponent";
import axios from "axios";

const fetchNoteBooks = async (abctrl) => {
    const { data } = await axios.get("/api/noteBooks/admin", {
        signal: abctrl.signal,
    });
    return data
}

const deleteNoteBook = async (noteBookId) => {
    const { data } = await axios.delete(`/api/noteBooks/admin/${noteBookId}`);
    return data
}

const AdminNoteBook = () => {
    return <NoteBookComponent fetchNoteBooks={fetchNoteBooks} deleteNoteBook={deleteNoteBook} />;
};

export default AdminNoteBook;